import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ListDistributorStockComponent } from './list-distributor-stock/list-distributor-stock.component';
import { permissionGuard } from 'src/app/shared/guards/permission/permission.guard';
import { Permission } from 'src/app/shared/models/permission/permission-dto';
import { UpdateDistributorStockComponent } from './update-distributor-stock/update-distributor-stock.component';

const routes: Routes = [
  {
    path: '',
    canActivate: [permissionGuard],
    data: { permission: Permission.LIST_DISTRIBUTOR_STOCK },
    component: ListDistributorStockComponent
  },
  {
    path: 'update',
    canActivate: [permissionGuard],
    data: { permission: Permission.UPDATE_DISTRIBUTOR_STOCK },
    component: UpdateDistributorStockComponent
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class DistributorStockRoutingModule {}
